import { render } from "./feature-locked.vue.js?vue&type=template&id=2bfb9773!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./feature-locked.vue?vue&type=template&id=2bfb9773"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__